import { testimonials as initialTestimonials } from "@/data/dummy";
import { useRef, useState } from "react";
import { Button } from "./ui/button";
import Link from "next/link";
import { Quote } from "lucide-react";
// import { Link } from "lucide-react";

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState(initialTestimonials);
  const [animatingCard, setAnimatingCard] = useState<number | null>(null);

  const stickyRef = useRef<HTMLDivElement>(null);

  const handleCardClick = (index: number) => {
    setAnimatingCard(index);

    setTimeout(() => {
      setTestimonials((prev) => {
        const newArr = [...prev];
        const [clicked] = newArr.splice(index, 1);
        newArr.push(clicked);
        return newArr;
      });
      setAnimatingCard(null);
    }, 600);
  };

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header - Consistent with reference design */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 bg-[#0092B8]/20 text-[#0092B8] text-xs uppercase font-semibold tracking-wide mb-4">
            TESTIMONIALS
          </span>

          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
            What Our Clients Say
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[90%] mx-auto">
          {testimonials.slice(0, 3).map((item, index) => (
            <div
              key={index}
              onClick={() => handleCardClick(index)}
              className="group relative bg-white rounded-2xl p-8 border border-gray-100 hover:shadow-[0_20px_50px_rgba(0,0,0,0.12)] transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              {/* Stars - Using SVG stars matching reference style */}
              <div className="flex items-center gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-4 h-4 text-[#E6A84B] fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Quote Icon - Matching reference subtle styling */}
              <div className="absolute top-6 right-6 opacity-20 group-hover:opacity-40 transition-opacity duration-300">
                <svg
                  className="w-10 h-10 text-[#0F2929]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 9.75L12 13.5l3.75-3.75"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 15L12 18.75 15.75 15"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5L12 8.25 15.75 4.5"
                  />
                </svg>
              </div>

              {/* Title - Bold project type */}
              {/* <h3 className="text-xl font-bold text-[#0F2929] mb-4">
                {item.title || item.category || "Client Testimonial"}
              </h3> */}

              {/* Testimonial Quote */}
              <p className="text-gray-600 leading-relaxed mb-8">{item.quote}</p>

              {/* Client Info - Matching reference user section style */}
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                {item.image ? (
                  <img
                    // src={item.image}
                    src="/images/copy.jpg"
                    alt={item.name}
                    className="w-12 h-12 rounded-full object-cover ring-2 ring-[#0092B8]/30"
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#0092B8]/30 to-[#0092B8]/10 flex items-center justify-center font-semibold text-[#0F2929]">
                    {item.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </div>
                )}

                <div>
                  <h4 className="font-bold text-[#0F2929]">{item.name}</h4>
                  {item.role && (
                    <p className="text-sm text-gray-500">{item.role}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
